import type { ZodSchema } from '@vy/utils';
import type { FormDrawerProps } from '../../FormDrawer';
import { PaddleRegistrationFooter } from './components/PaddleRegistrationFooter';
import { PaddleRegistrationForm } from './components/PaddleRegistrationForm';
import type { PaddleRegisterFormValues } from './PaddleRegisterFormSchema';
import { PaddleRegisterFormSchema } from './PaddleRegisterFormSchema';

export const RegisterToPaddleComponents: FormDrawerProps<ZodSchema<PaddleRegisterFormValues>> = {
  zodSchema: PaddleRegisterFormSchema,
  ContentComponent: PaddleRegistrationForm,
  Footer: PaddleRegistrationFooter,
};
